// @ts-nocheck
import React, { useState } from 'react';
import {
  loadUserProfileGroups,
  exportUserProfileGroupData,
} from '../../../../actions/userProfileGroupActions';
import { Link, useLocation } from 'react-router-dom';
import { Table, SimpleTextFilter, getVisibleColumns } from '../../../common/Table';
import { CommaNumber_NoDecimal } from '../../../../util/formatter';
import Loading from '../../../common/Loading';
import KwPanel from '../../../common/KwPanel';
import {
  useTableSettings,
  getTableSettingsDefaults,
} from '../../../../hooks/useTableSettings';
import { useTranslation } from 'react-i18next';

function UserProfileGroupList({ reload }) {
  const { t } = useTranslation();
  const allColumns = ['name', 'memberCount'];
  const defaultVisibleColumns = allColumns;
  const [userProfileGroups, setUserProfileGroups] = useState();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const { tableSettings, handleSetTableSettings: setTableSettings, filters, filterChange, isLoading } =
    useTableSettings(
      'userprofilegrouplist-settings',
      getTableSettingsDefaults({ defaultSort: 'name', defaultVisibleColumns }),
      null,
      loadUserProfileGroups,
      setUserProfileGroups,
      reload,
      t('Failed to load groups')
    );

  // The base config of the columns, this will be filtered based on the visible (above)
  let columnsConfig = [
    {
      Key: 'name',
      Label: t('Name'),
      width: '40%',
      Render: (item) => (
        <Link to={'/settings/user-profile-group/' + item.id}>{item.name}</Link>
      ),
      Filter: {
        Render: (col) => (
          <SimpleTextFilter
            Key={col.Key}
            Value={col.filterValue ?? params.get(`f_${col.Key}`) ?? ''}
            onChange={(value) => filterChange(col.Key, value)}
            testId="user-group-name-filter"
          />
        ),
      },
    },
    {
      Key: 'memberCount',
      Label: t('Members'),
      width: '30%',
      className: 'text-right num no-wrap',
      Render: (item) => CommaNumber_NoDecimal(item.memberCount),
    },
  ];

  // filter
  const visibleColumns = tableSettings.columns ?? defaultVisibleColumns;
  const columns = getVisibleColumns(visibleColumns, columnsConfig);

  // return an alaska table
  return userProfileGroups ? (
    <KwPanel className="mb-4">
      <Table
        columns={columns}
        allColumns={allColumns}
        rows={userProfileGroups.data.map((x) => {
          return { Key: x.id, ...x };
        })}
        totalRowCount={userProfileGroups.totalRowCount}
        filteredRowCount={userProfileGroups.filteredRowCount}
        tableSettings={tableSettings}
        setTableSettings={setTableSettings}
        isLoading={isLoading}
        filters={filters}
        filterChange={filterChange}
        exportData={exportUserProfileGroupData}
      />
    </KwPanel>
  ) : (
    <Loading />
  );
}
export default UserProfileGroupList;
